import rutasAuth from "./routes";
import rutasAuthCMS from "./routesCMS";

const apiKey = process.env.REACT_APP_MAP_KEY;

export { rutasAuth as rutas, rutasAuthCMS as rutasCMS, apiKey}